export const EmptyCartState = () => (
  <div className="flex flex-col items-center justify-center w-full py-16 px-4 bg-transparent dark:bg-[#1E1E22] rounded-2xl max-w-[600px] mx-auto min-h-[350px]">
    <div className="w-32 h-32 mb-6">
      <img
        src="/images/cart.png"
        alt="Empty Cart"
        className="w-full h-full object-contain"
      />
    </div>
    <h3 className="text-xl font-bold mb-2 text-black dark:text-white">
      No items yet
    </h3>
    <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
      Make selections to view list here.
    </p>
  </div>
);
